(function() {
  'use strict';

  const CONFIG = {
    serviceablePincodes: window.pincodeSettings?.serviceablePincodes || [],
    cookieName: 'validated_pincode_global',
    cookieDays: 365,
    popupId: 'pincode-validation-popup'
  };

  function setCookie(name, value, days) {
    const expires = new Date();
    expires.setTime(expires.getTime() + (days * 24 * 60 * 60 * 1000));
    document.cookie = name + '=' + value + ';expires=' + expires.toUTCString() + ';path=/';
  }

  function getCookie(name) {
    const nameEQ = name + '=';
    const ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  function isPincodeValidated() {
    return !!getCookie(CONFIG.cookieName);
  }

  function saveValidatedPincode(pincode) {
    setCookie(CONFIG.cookieName, pincode, CONFIG.cookieDays);
  }

  function getValidatedPincode() {
    return getCookie(CONFIG.cookieName);
  }

  function validatePincode(pincode) {
    pincode = pincode.trim();
    
    if (!/^\d{6}$/.test(pincode)) {
      return {
        valid: false,
        message: 'Please enter a valid 6-digit pincode'
      };
    }

    const isServiceable = CONFIG.serviceablePincodes.some(p => p.trim() === pincode);
    
    if (isServiceable) {
      return {
        valid: true,
        message: '✓ Great! We deliver to pincode ' + pincode
      };
    } else {
      return {
        valid: false,
        message: 'Sorry, we currently don\'t deliver to pincode ' + pincode
      };
    }
  }

  function showPincodePopup(productTitle, callback) {
    let popup = document.getElementById(CONFIG.popupId);
    
    if (!popup) {
      createPopup();
      popup = document.getElementById(CONFIG.popupId);
    }

    popup.style.display = 'flex';
    document.body.style.overflow = 'hidden';

    const input = popup.querySelector('.pincode-input');
    const checkBtn = popup.querySelector('.pincode-check-btn');
    const messageDiv = popup.querySelector('.pincode-message');
    const closeBtn = popup.querySelector('.pincode-popup-close');
    const titleEl = popup.querySelector('.pincode-product-title');

    if (titleEl && productTitle) {
      titleEl.textContent = productTitle;
      titleEl.style.display = 'block';
    }

    const savedPincode = getValidatedPincode();
    input.value = savedPincode || '';
    messageDiv.style.display = 'none';
    setTimeout(() => input.focus(), 100);

    const validateHandler = () => {
      const pincode = input.value;
      const result = validatePincode(pincode);
      
      const iconSuccess = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z" fill="#4CAF50"/></svg>';
      const iconError = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none"><path d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM11 15H9V13H11V15ZM11 11H9V5H11V11Z" fill="#F44336"/></svg>';
      
      messageDiv.className = 'pincode-message ' + (result.valid ? 'success' : 'error');
      messageDiv.querySelector('.pincode-message-content').innerHTML = 
        (result.valid ? iconSuccess : iconError) + '<div>' + result.message + '</div>';
      messageDiv.style.display = 'block';

      if (result.valid) {
        saveValidatedPincode(pincode);
        
        setTimeout(() => {
          closePopup();
          if (callback) callback(true, pincode);
        }, 1500);
      }
    };

    const closePopup = () => {
      popup.style.display = 'none';
      document.body.style.overflow = '';
      checkBtn.removeEventListener('click', validateHandler);
      input.removeEventListener('keypress', enterHandler);
      closeBtn.removeEventListener('click', closePopup);
      popup.removeEventListener('click', overlayClick);
    };

    const enterHandler = (e) => {
      if (e.key === 'Enter') {
        e.preventDefault();
        validateHandler();
      }
    };

    const overlayClick = (e) => {
      if (e.target === popup) {
        closePopup();
      }
    };

    checkBtn.addEventListener('click', validateHandler);
    input.addEventListener('keypress', enterHandler);
    closeBtn.addEventListener('click', closePopup);
    popup.addEventListener('click', overlayClick);

    input.addEventListener('input', function() {
      this.value = this.value.replace(/[^0-9]/g, '');
    });

    const escHandler = (e) => {
      if (e.key === 'Escape') {
        closePopup();
        document.removeEventListener('keydown', escHandler);
      }
    };
    document.addEventListener('keydown', escHandler);
  }

  function createPopup() {
    const popupHTML = `
      <div id="${CONFIG.popupId}" class="pincode-popup-overlay" style="display: none;">
        <div class="pincode-popup-container">
          <div class="pincode-popup-content">
            <button type="button" class="pincode-popup-close" aria-label="Close">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M13 1L1 13M1 1L13 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>
              </svg>
            </button>
            
            <div class="pincode-popup-header">
              <svg width="40" height="40" viewBox="0 0 40 40" fill="none" class="pincode-icon">
                <path d="M20 3.33333C15.4167 3.33333 11.6667 7.08333 11.6667 11.6667C11.6667 18.3333 20 30 20 30C20 30 28.3333 18.3333 28.3333 11.6667C28.3333 7.08333 24.5833 3.33333 20 3.33333ZM20 15C18.1667 15 16.6667 13.5 16.6667 11.6667C16.6667 9.83333 18.1667 8.33333 20 8.33333C21.8333 8.33333 23.3333 9.83333 23.3333 11.6667C23.3333 13.5 21.8333 15 20 15Z" fill="#4CAF50"/>
              </svg>
              <h3>Check Delivery Availability</h3>
              <p class="pincode-product-title" style="display: none; margin: 10px 0; font-weight: 600; color: #666;"></p>
              <p>Enter your pincode to check if we deliver this product to your area</p>
            </div>

            <div class="pincode-popup-body">
              <div class="pincode-input-group">
                <input 
                  type="text" 
                  class="pincode-input" 
                  placeholder="Enter 6-digit pincode"
                  maxlength="6"
                  pattern="[0-9]{6}"
                >
                <button type="button" class="pincode-check-btn">Check</button>
              </div>
              
              <div class="pincode-message" style="display: none;">
                <div class="pincode-message-content"></div>
              </div>

              <div class="pincode-info">
                <p><strong>Note:</strong> This product is only available for delivery in select locations.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    `;

    const style = `
      <style>
      .pincode-popup-overlay {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.6);
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        animation: pincodePopupFadeIn 0.3s ease;
      }
      @keyframes pincodePopupFadeIn {
        from { opacity: 0; }
        to { opacity: 1; }
      }
      .pincode-popup-container {
        max-width: 500px;
        width: 100%;
        animation: pincodePopupSlideUp 0.3s ease;
      }
      @keyframes pincodePopupSlideUp {
        from { transform: translateY(20px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      .pincode-popup-content {
        background: #fff;
        border-radius: 12px;
        padding: 30px;
        position: relative;
        box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
      }
      .pincode-popup-close {
        position: absolute;
        top: 15px;
        right: 15px;
        background: transparent;
        border: none;
        cursor: pointer;
        padding: 8px;
        color: #666;
        transition: color 0.2s;
        z-index: 1;
      }
      .pincode-popup-close:hover {
        color: #000;
      }
      .pincode-popup-header {
        text-align: center;
        margin-bottom: 25px;
      }
      .pincode-icon {
        margin-bottom: 15px;
      }
      .pincode-popup-header h3 {
        margin: 0 0 10px 0;
        font-size: 22px;
        font-weight: 600;
        color: #111;
      }
      .pincode-popup-header p {
        margin: 0;
        font-size: 14px;
        color: #666;
      }
      .pincode-popup-body {
        margin-top: 20px;
      }
      .pincode-input-group {
        display: flex;
        gap: 10px;
        margin-bottom: 15px;
      }
      .pincode-input {
        flex: 1;
        padding: 12px 16px;
        border: 2px solid #ddd;
        border-radius: 8px;
        font-size: 16px;
        transition: border-color 0.3s;
      }
      .pincode-input:focus {
        outline: none;
        border-color: #4CAF50;
      }
      .pincode-check-btn {
        padding: 12px 28px;
        background: #111;
        color: #fff;
        border: none;
        border-radius: 8px;
        font-size: 16px;
        font-weight: 600;
        cursor: pointer;
        transition: background 0.3s;
        white-space: nowrap;
      }
      .pincode-check-btn:hover {
        background: #111;
        color: #fff;
      }
      .pincode-message {
        padding: 14px;
        border-radius: 8px;
        margin-bottom: 15px;
        animation: pincodeMessageSlide 0.3s ease;
      }
      @keyframes pincodeMessageSlide {
        from { transform: translateY(-10px); opacity: 0; }
        to { transform: translateY(0); opacity: 1; }
      }
      .pincode-message.success {
        background: #E8F5E9;
        border: 1px solid #4CAF50;
      }
      .pincode-message.error {
        background: #FFEBEE;
        border: 1px solid #F44336;
      }
      .pincode-message-content {
        display: flex;
        align-items: flex-start;
        gap: 10px;
        font-size: 14px;
      }
      .pincode-message.success .pincode-message-content {
        color: #2E7D32;
      }
      .pincode-message.error .pincode-message-content {
        color: #C62828;
      }
      .pincode-info {
        padding: 12px;
        background: #F5F5F5;
        border-radius: 8px;
        font-size: 13px;
        color: #666;
      }
      .pincode-info p {
        margin: 0;
      }
      @media (max-width: 576px) {
        .pincode-popup-content {
          padding: 25px 20px;
        }
        .pincode-popup-header h3 {
          font-size: 20px;
        }
        .pincode-input-group {
          flex-direction: column;
        }
        .pincode-check-btn {
          width: 100%;
        }
      }
      </style>
    `;

    document.body.insertAdjacentHTML('beforeend', popupHTML);
    document.head.insertAdjacentHTML('beforeend', style);
  }

  function requiresPincodeCheck(element) {
    if (!element) return false;
    if (element.dataset?.requiresPincodeCheck === 'true') return true;
    const productItem = element.closest('[data-requires-pincode-check="true"]');
    return !!productItem;
  }

  function getProductTitle(element) {
    if (!element) return '';
    const titleEl = element.querySelector('.bls__product-title, .product-title, h2, h3');
    if (titleEl) return titleEl.textContent.trim();
    const productItem = element.closest('[data-product-title]');
    if (productItem) return productItem.dataset.productTitle;
    return 'this product';
  }

  function interceptCartCheckout() {
    const checkoutButtons = document.querySelectorAll('[name="checkout"], .cart__checkout-button, .bls-btn-checkout');
    
    checkoutButtons.forEach(button => {
      button.addEventListener('click', function(e) {
        const hasRestrictedItems = document.querySelector('.cart-item[data-requires-pincode-check="true"], .bls-minicart-item[data-requires-pincode-check="true"]');

        if (hasRestrictedItems && !isPincodeValidated()) {
          e.preventDefault();
          e.stopPropagation();
          alert('Please add valid delivery pincode for restricted products. You can do this from the product page.');
          return false;
        }
      });
    });
  }

  function interceptBuyItNowButtons() {
    document.addEventListener('click', function(e) {
      const target = e.target;
      const buyButton = target.closest('.shopify-payment-button__button, [data-shopify="payment-button"]');
      
      if (buyButton) {
        const productElement = buyButton.closest('[data-product-id]');
        
        if (productElement) {
          const productTitle = getProductTitle(productElement);
          
          if (requiresPincodeCheck(productElement) && !isPincodeValidated()) {
            e.preventDefault();
            e.stopPropagation();
            e.stopImmediatePropagation();
            
            showPincodePopup(productTitle, (validated) => {
              if (validated) {
                buyButton.click();
              }
            });
            
            return false;
          }
        }
      }
    }, true);
  }

  function interceptProductJS() {
    document.addEventListener('click', function(e) {
      const target = e.target;
      const addButton = target.closest('.button-add-cart-qv, .add-cart-button, [type="submit"][name="add"], .bls__js-addtocart, .bls__js-addtocart-page');
      
      if (!addButton) return;

      const productElement = addButton.closest('.bls__product-quickview, .bls__product-details-infor, .bls__product-item, [data-product-id]');
      
      if (!productElement) return;

      const productTitle = getProductTitle(productElement);
      
      if (requiresPincodeCheck(productElement) && !isPincodeValidated()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        showPincodePopup(productTitle, (validated) => {
          if (validated) {
            const clickEvent = new MouseEvent('click', {
              bubbles: true,
              cancelable: true,
              view: window
            });
            
            addButton._pincodeValidated = true;
            addButton.dispatchEvent(clickEvent);
            
            setTimeout(() => {
              delete addButton._pincodeValidated;
            }, 100);
          }
        });
        
        return false;
      }
      
      if (addButton._pincodeValidated) {
        return true;
      }
    }, true);
  }

  function init() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', createPopup);
    } else {
      createPopup();
    }

    interceptProductJS();
    interceptBuyItNowButtons();

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', interceptCartCheckout);
    } else {
      interceptCartCheckout();
    }
  }

  init();

  window.PincodeValidation = {
    showPopup: showPincodePopup,
    validate: validatePincode,
    isValidated: isPincodeValidated,
    getValidated: getValidatedPincode,
    saveValidated: saveValidatedPincode
  };

})();